import { convertValuesToFormData } from '../../components/react-hook-form/utils/convert-values';
import { EndPointService } from '../api-handlers/axios';

const ROUTE = 'rewards';

const resolveImageFile = (image: any) => {
    if (!image) return undefined;
    if (Array.isArray(image)) return image[0];
    if (typeof FileList !== 'undefined' && image instanceof FileList) return image[0];
    if (image instanceof File) return image;
    return undefined;
};

const list = (params: any) => EndPointService.get(`/${ROUTE}`, params);
const get = (id: string) => EndPointService.get(`/${ROUTE}/${id}`);
const update = (id: string, data: any) => {
    const payload: any = {
        title: data.title,
        description: data.description,
        pointsRequired: data.pointsRequired,
        stockQuantity: data.stockQuantity,
        type: data.type?.value,
        isActive: data.isActive,
        image: resolveImageFile(data.image),
        hasVariants: data.hasVariants,
    };

    const keepImages = data.images
        ? data.images.filter((img: any) => img.url && !img.file).map((img: any) => img.url)
        : [];
    payload.keepImages = JSON.stringify(keepImages);

    if (data.images && Array.isArray(data.images)) {
        data.images.forEach((img: any, index: number) => {
            if (img.file) {
                const file = resolveImageFile(img.file);
                if (file) {
                    payload[`reward_image_${index}`] = file;
                }
            }
        });
    }

    if (data.hasVariants && data.variants) {
        const variantsData = data.variants.map((v: any, index: number) => {
            const { image, images, ...rest } = v;
            const file = resolveImageFile(image);
            if (file) {
                payload[`variant_image_${index}`] = file;
            }

            const keepImages = images
                ? images.filter((img: any) => img.url && !img.file).map((img: any) => img.url)
                : [];
            rest.keepImages = JSON.stringify(keepImages);

            if (images && Array.isArray(images)) {
                images.forEach((img: any, j: number) => {
                    if (img.file) {
                        const file = resolveImageFile(img.file);
                        if (file) {
                            payload[`variant_image_${index}_${j}`] = file;
                        }
                    }
                });
            }

            return rest;
        });
        payload.variants = JSON.stringify(variantsData);
    }

    const formData = convertValuesToFormData(payload) || {};

    return EndPointService.patch(`/${ROUTE}/${id}`, formData);
};

const create = (data: any) => {
    const payload: any = {
        title: data.title,
        description: data.description,
        pointsRequired: data.pointsRequired,
        stockQuantity: data.stockQuantity,
        type: data.type?.value,
        isActive: data.isActive,
        image: resolveImageFile(data.image),
        hasVariants: data.hasVariants,
    };

    if (data.images && Array.isArray(data.images)) {
        data.images.forEach((img: any, index: number) => {
            const file = resolveImageFile(img.file);
            if (file) {
                payload[`reward_image_${index}`] = file;
            }
        });
    }

    if (data.hasVariants && data.variants) {
        const variantsData = data.variants.map((v: any, index: number) => {
            const { image, images, ...rest } = v;
            const file = resolveImageFile(image);
            if (file) {
                payload[`variant_image_${index}`] = file;
            }

            if (images && Array.isArray(images)) {
                images.forEach((img: any, j: number) => {
                    const file = resolveImageFile(img.file);
                    if (file) {
                        payload[`variant_image_${index}_${j}`] = file;
                    }
                });
            }

            return rest;
        });
        payload.variants = JSON.stringify(variantsData);
    }

    const formData = convertValuesToFormData(payload) || {};

    return EndPointService.post(`/${ROUTE}/`, formData);
};
const remove = (id: string) => EndPointService.delete(`/${ROUTE}/${id}`);
const removeVariant = (id: string | number) => EndPointService.delete(`/${ROUTE}/variants/${id}`);

const listAllRedeemed = (params?: any) => EndPointService.get(`/user-rewards`, params);

const updateRedemptionStatus = (id: number, status: string, comment?: string) =>
    EndPointService.patch(`/user-rewards/${id}/status`, { status, comment });

const getColors = () => EndPointService.get(`/${ROUTE}/colors`);

export default {
    list,
    get,
    update,
    create,
    remove,
    removeVariant,
    listAllRedeemed,
    updateRedemptionStatus,
    getColors,
};
